import { FormattedMessage } from 'react-intl';

export const EventText = () => {
  return <FormattedMessage id="lang-event" />;
};

export const ArenaText = () => {
  return <FormattedMessage id="lang-inspire-arena" />;
};

export const PrivacyPolicyText = () => {
  return <FormattedMessage id="lang-privacy-policy" />;
};

export const TermsConditionsText = () => {
  return <FormattedMessage id="lang-terms" />;
};

export const FirstNameErrorText = () => {
  return <FormattedMessage id="lang-error-firstname" />;
};

export const LastNameErrorText = () => {
  return <FormattedMessage id="lang-error-lastname" />;
};

export const EmailErrorText = () => {
  return <FormattedMessage id="lang-error-email" />;
};

export const PhoneErrorText = () => {
  return <FormattedMessage id="lang-error-phone" />;
};

export const PhoneRequiredErrorText = () => {
  return <FormattedMessage id="lang-error-phone-required" />;
};

export const AttendeesArenaRequiredErrorText = () => {
  return <FormattedMessage id="lang-error-attendees-arena" />;
};

export const AttendeesEventRequiredErrorText = () => {
  return <FormattedMessage id="lang-error-attendees-event" />;
};

export const EmailValidErrorText = () => {
  return <FormattedMessage id="lang-error-email-valid" />;
};

export const CompanyErrorText = () => {
  return <FormattedMessage id="lang-error-company" />;
};

export const EventStartDateError = () => {
  return <FormattedMessage id="lang-error-event-start-date" />;
};
export const EventEndDateError = () => {
  return <FormattedMessage id="lang-error-event-end-date" />;
};

export const EventErrorText = () => {
  return <FormattedMessage id="lang-error-event" />;
};

export const UploadFileDescription1 = () => {
  return <FormattedMessage id="lang-upload-file-description-1" />;
};

export const UploadFileDescription2 = () => {
  return <FormattedMessage id="lang-upload-file-description-2" />;
};

export const UploadFileDescription3 = () => {
  return <FormattedMessage id="lang-upload-file-description-3" />;
};

export const TermsErrorText = () => {
  return <FormattedMessage id="lang-error-terms" />;
};

// NOTE: Not Found Descriptions

export const NotFoundDesc1Text = () => {
  // We apologize for any inconvenience caused while using the site.
  return <FormattedMessage id="lang-not-found-desc-1" />;
};

export const NotFoundDesc2Text = () => {
  // The page you requested has either been deleted, moved, or the address is incorrect.
  return <FormattedMessage id="lang-not-found-desc-2" />;
};

export const NotFoundDesc3Text = () => {
  // Please navigate to a different page or check the address again.
  return <FormattedMessage id="lang-not-found-desc-3" />;
};

// NOTE: Required Text
export const UploadFilesLimitRequiredText = () => {
  // You can upload up to five files.
  return <FormattedMessage id="lang-upload-files-limit-text" />;
};

export const UploadFilesInvalidText = () => {
  // You can upload up to five files.
  return <FormattedMessage id="lang-upload-files-invalid-text" />;
};

export const UploadFilesSizeLimitText = () => {
  // You can upload up to five files.
  return <FormattedMessage id="lang-upload-files-size-limit-text" />;
};

export const CaptchaRequiredText = () => {
  return <FormattedMessage id="lang-captcha-required" />;
};

// NOTE: Input Placeholder

// NOTE: Input Label
export const UploadFilesText = () => {
  // Upload a File
  return <FormattedMessage id="lang-upload-files-text" />;
};

// NOTE: Footer
export const ConnectWithUsText = () => {
  //Connect With Us
  return <FormattedMessage id="lang-connect-with-us" />;
};

export const HotelReservationText = () => {
  // Hotel Reservation
  return <FormattedMessage id="lang-hotel-reservation" />;
};

export const PhoneText = () => {
  // Hotel Reservation
  return <FormattedMessage id="lang-phone" />;
};

export const FaxText = () => {
  // Hotel Reservation
  return <FormattedMessage id="lang-fax" />;
};
